import { useAuthentication } from '@topcon/topcon-utils';

import { useAppService } from '../../providers/app/app.context';
import { useCriticalFontsReady } from '../../hooks/useCriticalFontsReady';
import GenericOverview from './GenericOverview';
import MyOverview from './MyOverview';
import OverviewLoader from './OverviewLoader';

function Overview() {
  const { bpId } = useAuthentication();
  const { currentBusinessPartner, loadedBusinessPartner, loadedIdentity } = useAppService();
  const isCriticalFontsReady = useCriticalFontsReady();

  if (!loadedBusinessPartner || !loadedIdentity || !isCriticalFontsReady) {
    // Auth session knows the BP context before PAP current-BP data arrives.
    return <OverviewLoader variant={bpId ? 'organization' : 'personal'} />;
  }

  if (currentBusinessPartner) return <GenericOverview />;
  return <MyOverview />;
}

export default Overview;
